import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: '首页', href: '/' },
  { label: '网红黑料', href: '/category/wanghong-heliao' },
  { label: '明星塌房', href: '/category/mingxing-tafang' },
  { label: '博主爆料', href: '/category/bozhu-baoliao' },
  { label: '综艺吃瓜', href: '/category/zongyi-chigua' },
  { label: '影视揭秘', href: '/category/dianshi-juqing' },
  { label: '关于我们', href: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link to="/" className="flex items-center gap-2 shrink-0">
            <span className={`font-heading text-xl md:text-2xl font-bold tracking-tight whitespace-nowrap ${
              scrolled ? 'text-primary-600' : 'text-background-50'
            }`}>
              五一黑料网
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.href ||
                (link.href !== '/' && location.pathname.startsWith(link.href));
              return (
                <Link
                  key={link.href}
                  to={link.href}
                  className={`px-3 py-2 text-sm font-medium rounded-lg transition-colors duration-200 whitespace-nowrap ${
                    isActive
                      ? scrolled
                        ? 'text-primary-600 bg-primary-100'
                        : 'text-background-50 bg-white/20'
                      : scrolled
                        ? 'text-foreground-600 hover:text-primary-600 hover:bg-background-100'
                        : 'text-background-50/80 hover:text-background-50 hover:bg-white/10'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
          </div>

          <button
            className="md:hidden flex items-center justify-center w-10 h-10 rounded-lg"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="切换菜单"
          >
            <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl ${
              scrolled ? 'text-foreground-800' : 'text-background-50'
            }`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.href ||
                (link.href !== '/' && location.pathname.startsWith(link.href));
              return (
                <Link
                  key={link.href}
                  to={link.href}
                  className={`px-3 py-2.5 text-sm font-medium rounded-lg transition-colors duration-200 whitespace-nowrap ${
                    isActive
                      ? 'text-primary-600 bg-primary-100'
                      : 'text-foreground-600 hover:text-primary-600 hover:bg-background-100'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
          </div>
        </div>
      )}
    </nav>
  );
}